import {Component} from 'panel';
import moment from 'moment';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class LastUpdated extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'is-compact': `boolean`,
      'last-refresh-date': {type: `string`, default: new Date().toISOString()},
      'preface-text': `string`,
      'refresh-interval-ms': {type: `number`, default: 10 * 60 * 1000}, // 10 mins
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      helpers: {
        getLastRefreshRelativeFormat: () => moment(this.attr(`last-refresh-date`)).fromNow(),
      },
    };
  }

  attributeChangedCallback(name) {
    super.attributeChangedCallback(...arguments);
    switch (name) {
      case `last-refresh-date`:
        this.updateInterval();
        this.update();
        break;
      case `refresh-interval-ms`:
        this.updateInterval();
        break;
    }
  }

  connectedCallback() {
    super.connectedCallback(...arguments);
    this.updateInterval();
    this._renderTimer = setInterval(() => this.update(), 30 * 1000);
  }

  disconnectedCallback() {
    clearTimeout(this._starter);
    clearInterval(this._timer);
    clearInterval(this._renderTimer);
    super.disconnectedCallback(...arguments);
  }

  dispatchRefresh() {
    this.dispatchEvent(new CustomEvent(`refresh`));
  }

  updateInterval() {
    clearTimeout(this._starter);
    clearInterval(this._timer);
    const lastRefreshed = moment(this.attr(`last-refresh-date`));
    const nextRefreshMs = this.attr(`refresh-interval-ms`) - moment().diff(lastRefreshed, `milliseconds`);
    this._starter = setTimeout(() => {
      this.dispatchRefresh();
      this._timer = setInterval(() => this.dispatchRefresh(), this.attr(`refresh-interval-ms`));
    }, nextRefreshMs);
  }
}

export const LastUpdatedEl = defineAndMakeJsxFactory(`mp-last-updated`, LastUpdated);
